// extracted by mini-css-extract-plugin
export default {"popupWrapper":"About_popupWrapper__QqXd0","popupTriggerText":"About_popupTriggerText__SBX7L","popupContainer":"About_popupContainer__l8lFm"};